import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  similarNews: {
    id: 'views.News.components.FeaturedNews.similarNews',
    defaultMessage: 'PODOBNE AKTUALNOŚCI'
  }
});



// WEBPACK FOOTER //
// ./src/views/News/components/FeaturedNews/FeaturedNews.intl.js